export default __webpack_public_path__ + "static/media/blobs-no-2.f6eea4db.mid";